<template>
  <div id="course_assessment_setting" class="container">
    <el-row style="font-size: 20px" class="course_title">
        <el-col :span="23">
        <div class="course_title_name">课程考核设置</div>
      </el-col>
      <el-col :span="1">
        <el-button
          type="primary"
          size="small"
          class="course_save"
          @click="saveCheckScaleSetting"
          >保存</el-button
        >
      </el-col>
    </el-row>
    <el-form ref="tableForm" :model="tableForm" style="margin-bottom: 40px">
      <el-table
        :data="tableForm.tableData"
        :span-method="objectSpanMethod"
        border
        style="width: 80%; margin: 20px auto 0"
        :header-cell-style="{ 'text-align': 'center' }"
        class="formTable"
      >
        <el-table-column
          prop="checkIndicators"
          label="考核指标"
          align="center"
          width="200"
        >
        </el-table-column>
        <el-table-column
          prop="examinationContent"
          label="考核内容"
          align="center"
          width="350"
        >
        </el-table-column>

        <el-table-column 
          prop="scoringRule"
          label="评分规则"
          align="center"
          >

        </el-table-column>

        <el-table-column
          prop="proportion"
          label="占比 ( 100% )"
          align="center"
          width="120"
        >
          <template slot-scope="scope">
            <el-form-item
              :prop="'tableData.' + scope.$index + '.proportion'"
              :rules="{
                validator: validAssessmentPerformanceRatio,
                trigger: 'blur',
              }"
            >
              <el-input v-model="scope.row.proportion"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
      <div class="tips">温馨提示：当考核占比值为0时，指标不参与考核。</div>
    </el-form>
    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        padding-left: 380px;
      "
    >
      <el-form ref="form" :model="form" :rules="rules" style="width: 100%">
        <h5 class="form_item_title">学习时长指标考核设置 :</h5>
        <el-form-item
          label="出勤目标学时数:"
          size="small"
          prop="attendancePeriodsTarget"
        >
          <el-input
            class="form_inpt"
            v-model="form.attendancePeriodsTarget"
          ></el-input>
          <span class="content"> 说明: 1学时为45分钟 </span>
        </el-form-item>
        <el-form-item label="当前线上资源总学时数:" size="small">
          <span class="content"> {{ form.currentOnlineResPeriods }}学时 </span>
        </el-form-item>
        <el-form-item
          label="出勤目标最小线上学习学时数:"
          size="small"
          prop="studyOnlineMinPeriods"
        >
          <el-input
            class="form_inpt"
            v-model="form.studyOnlineMinPeriods"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="未达出勤目标最小学时数考核结果:"
          size="small"
          prop="attendanceResult"
        >
          <el-radio v-model="form.attendanceResult" :label="1"
            >出勤指标不得分</el-radio
          >
          <el-radio v-model="form.attendanceResult" :label="2"
            >课程不合格</el-radio
          >
        </el-form-item>
        <h5 class="form_item_title test">练习指标考核设置:</h5>
        <el-form-item label="当前课程知识点练习数:" size="small">
          <span class="content"> {{ form.currentKnowledgeNum }}套 </span>
        </el-form-item>
        <el-form-item
          label="练习最小完成套数:"
          size="small"
          prop="exerciseAnswerMinNum"
        >
          <el-input
            class="form_inpt"
            v-model="form.exerciseAnswerMinNum"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="未达练习目标最小答题数考核结果:"
          size="small"
          prop="exerciseAnswerResult"
        >
          <el-radio v-model="form.exerciseAnswerResult" :label="1"
            >练习指标不得分</el-radio
          >
          <el-radio v-model="form.exerciseAnswerResult" :label="2"
            >课程不合格</el-radio
          >
        </el-form-item>
        <h5 class="form_item_title test">阶段作业指标考核设置:</h5>
        <el-form-item label="当前测验套题数:" size="small">
          <span class="content"> {{ form.currentTestTotalNum }}套 </span>
        </el-form-item>
        <el-form-item
          label="测验目标最小完成套数:"
          size="small"
          prop="testMinNum"
        >
          <el-input class="form_inpt" v-model="form.testMinNum"></el-input>
        </el-form-item>
        <el-form-item
          label="未达测验目标最小完成套数考核结果:"
          size="small"
          prop="testResult"
        >
          <el-radio v-model="form.testResult" :label="1"
            >测验指标不得分</el-radio
          >
          <el-radio v-model="form.testResult" :label="2">课程不合格</el-radio>
        </el-form-item>
        <h5 class="form_item_title test">综合测评指标考核设置:</h5>
        <el-form-item
          label="综合测评最小完成套数:"
          size="small"
          prop="currentGeneralTestTotalNum"
        >
          <el-input
            class="form_inpt"
            v-model="form.currentGeneralTestTotalNum"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="未达测验目标最小完成套数考核结果:"
          size="small"
          prop="generalTestResult"
        >
          <el-radio v-model="form.generalTestResult" :label="1"
            >测评指标不得分</el-radio
          >
          <el-radio v-model="form.generalTestResult" :label="2"
            >课程不合格</el-radio
          >
        </el-form-item>
        <h5 class="form_item_title test">课堂出勤指标考核设置:</h5>
        <el-form-item
          label="课堂出勤目标学时数:"
          size="small"
          prop="classAttendancePeriodsTarget"
        >
          <el-input
            class="form_inpt"
            v-model="form.classAttendancePeriodsTarget"
          ></el-input>
          <span class="content"> 说明:  1学时为45分钟 </span>
        </el-form-item>
        <el-form-item label="当前集中学习学时数:" size="small">
          <span class="content">
            {{ form.currentTogetherLearnPeriods }}学时
          </span>
        </el-form-item>
        <el-form-item
          label="出勤目标最小集中学习学时数:"
          size="small"
          prop="studyTogetherMinPeriods"
        >
          <el-input
            class="form_inpt"
            v-model="form.studyTogetherMinPeriods"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="未达出勤目标最小学时数考核结果:"
          size="small"
          prop="classAttendanceResult"
        >
          <el-radio v-model="form.classAttendanceResult" :label="1"
            >课堂出勤指标不得分</el-radio
          >
          <el-radio v-model="form.classAttendanceResult" :label="2"
            >课程不合格</el-radio
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/assessment/courseAssessmentSetting.js'
export default {
  data() {
    const patternNatrualNum = /^[+]{0,1}(\d+)$/ //0和正整数
    const patternPositiveInteger = /^[1-9]\d*$/ //正整数
    const patternInteger = /^([+-]?[1-9]\d*|0)$/ //整数
    const patternZeroToHundredInteger = /^([0-9]{1,2}|100)$/ //0到100正整数

    const validAssessmentPerformanceRatio = (rule, value, callback) => {
      patternZeroToHundredInteger.test(value)
        ? callback()
        : callback(new Error('目标值必须为0~100正整数'))
    }
    const validPositiveInteger = (rule, value, callback) => {
      patternPositiveInteger.test(value)
        ? callback()
        : callback(new Error('目标值必须为正整数'))
    }
    const validNatrualNum = (rule, value, callback) => {
      patternNatrualNum.test(value)
        ? callback()
        : callback(new Error('目标值必须为0和正整数'))
    }
    const validInteger = (rule, value, callback) => {
      patternInteger.test(value)
        ? callback()
        : callback(new Error('目标值必须为整数'))
    }
    const validZeroToHundredInteger = (rule, value, callback) => {
      patternZeroToHundredInteger.test(value)
        ? callback()
        : callback(new Error('目标值必须为0到100正整数'))
    }
    const validMinPeriods = (rule, value, callback) => {
      if (!patternNatrualNum.test(value)) {
        callback(new Error('目标值必须为0和正整数'))
      }
      if (+value > +this.form.attendancePeriodsTarget) {
        callback(new Error('不能大于出勤目标学时数'))
      }
      callback()
    }
    const validTogetherMinPeriods = (rule, value, callback) => {
      if (!patternNatrualNum.test(value)) {
        callback(new Error('目标值必须为0和正整数'))
      }
      if (+value > +this.form.classAttendancePeriodsTarget) {
        callback(new Error('不能大于课堂出勤目标学时数'))
      }
      callback()
    }
    const validTestMinNum = (rule, value, callback) => {
      if (!patternNatrualNum.test(value)) {
        callback(new Error('目标值必须为0和正整数'))
      }
      if (+value > +this.form.currentTestTotalNum) {
        callback(new Error('不能大于当前测验套题数'))
      }
      callback()
    }
    const validInteractMinScoreTarget = (rule, value, callback) => {
      if (!patternNatrualNum.test(value)) {
        callback(new Error('目标值必须为0和正整数'))
      }
      if (+value > +this.form.interactScoreTarget) {
        callback(new Error('不能大于互动目标分数'))
      }
      callback()
    }
    const validExerciseAnswerMinNum = (rule, value, callback) => {
      if (!patternNatrualNum.test(value)) {
        callback(new Error('目标值必须为0和正整数'))
      }
      if (+value > +this.form.currentKnowledgeNum) {
        callback(new Error('不能大于已配练习题数'))
      }
      callback()
    }

    return {
      validAssessmentPerformanceRatio: validAssessmentPerformanceRatio,
      id: '',
      courseId: this.$route.query.courseId || this.$route.query.id,
      tableForm: {
        tableData: [
          {
            checkIndicators: '课程学习',
            examinationContent: '线上学习时长（1、视频，2、音频，3、视频链接）',
            scoringRule:'此三项分别按线上视频学习、线上练习及测试、线下面授累计有效学习时长，并按照占课程要求总学习时长的比例计算得分',
            proportion: '',
          },
          {
            checkIndicators: '',
            examinationContent: '练习测验时长（1、练习，2、测验）',
            scoringRule:'',
            proportion: '',
          },
          {
            checkIndicators: '',
            examinationContent: '集中学习时长（1、面授课，2、直播课）',
            scoringRule:'',
            proportion: '',
          },
          {
            checkIndicators: '',
            examinationContent: '知识点练习',
            scoringRule: '根据考生知识点练习的完成率计算该项得分',
            proportion: '',
          },
          {
            checkIndicators: '阶段作业',
            examinationContent: '阶段作业成绩',
            scoringRule: '根据考生完成每套阶段作业的情况计算该项得分',
            proportion: '',
          },
          {
            checkIndicators: '综合测评',
            examinationContent: '综合测评成绩',
            scoringRule: '根据考生的综合测评成绩计算该项得分',
            proportion: '',
          },
          {
            checkIndicators: '学习表现',
            examinationContent: '课堂出勤情况',
            scoringRule: '根据考生课堂出勤情况进行评分',
            proportion: '',
          },
          {
            checkIndicators: '',
            examinationContent: '诚信表现',
            scoringRule:
              '根据考生遵守国家法规法纪和学校校规校纪，以及课堂纪律和听课情况进行评分',
            proportion: '',
          },
          {
            checkIndicators: '',
            examinationContent: '作业完成情况',
            scoringRule:
              '根据考生课堂学习参与答疑讨论中表现的活跃度及发表观点的质量进行评分',
            proportion: '',
          },
          {
            checkIndicators: '',
            examinationContent: '互动（提问）',
            scoringRule: '按老师对学生发言进行评价',
            proportion: '',
          },
        ],
      },
      tableRules: {
        proportion: [
          { validator: validAssessmentPerformanceRatio, trigger: 'blur' },
        ],
      },
      form: {
        studyOnlineAndTogetherRatio: '', //考勤: 线上、集中学习占比
        exerciseRatio: '', //知识点练习占比
        testRatio: '', //阶段作业成绩 （测验）占比
        generalTestRatio: '', //综合成绩占比
        moralRatio: '', //政治思想品德
        classAttendanceRatio: '', //课堂出勤情况占比
        homeworkRatio: '', //作业: 线上练习占比
        interactScoreRatio: '', //互动学习占比

        attendancePeriodsTarget: '', //出勤目标学时数
        currentOnlineResPeriods: '', //当着线上视频资源学时数
        studyOnlineMinPeriods: '', //出勤目标最小线上学习学时数
        attendanceResult: 1, //出勤目标最小学时数考核结果

        currentKnowledgeNum: '', //当前课程知识点练习数
        exerciseAnswerMinNum: '', //练习最小答题数
        exerciseAnswerResult: 1, //未达练习目标最小答题数考核结果

        currentTestTotalNum: '', //当前测验套题数
        testMinNum: '', //测验目标最小完成套数
        testResult: 1, //未达测验目标最小完成套数考核结果

        currentGeneralTestTotalNum: '', //综合测评最小完成套数
        generalTestResult: 1, //未达测验目标最小完成套数考核结果

        classAttendancePeriodsTarget: '', //课堂出勤目标学时数
        currentTogetherLearnPeriods: '', //当前集中学习学时数
        studyTogetherMinPeriods: '', //出勤目标最小集中学习学时数
        classAttendanceResult: 1, //课堂出勤目标最小学时数考核结果
      },
      rules: {
        attendancePeriodsTarget: [
          { required: true, message: '不能为空' },
          { validator: validNatrualNum, trigger: 'blur' },
        ],
        studyOnlineMinPeriods: [
          { required: true, message: '不能为空' },
          { validator: validMinPeriods, trigger: 'blur' },
        ],
        classAttendancePeriodsTarget: [{ required: true, message: '不能为空' }],
        studyTogetherMinPeriods: [
          { required: true, message: '不能为空' },
          { validator: validTogetherMinPeriods, trigger: 'blur' },
        ],
        attendanceResult: [{ required: true, message: '不能为空' }],
        interactScoreTarget: [
          { required: true, message: '不能为空' },
          { validator: validPositiveInteger, trigger: 'blur' },
        ],
        interactLevelInvalidAnswerScore: [
          { required: true, message: '不能为空' },
          { validator: validInteger, trigger: 'blur' },
        ],
        interactLevelValidAnswerScore: [
          { required: true, message: '不能为空' },
          { validator: validInteger, trigger: 'blur' },
        ],
        interactLevelExcellentAnswerScore: [
          { required: true, message: '不能为空' },
          { validator: validInteger, trigger: 'blur' },
        ],
        interactMinScoreTarget: [
          { required: true, message: '不能为空' },
          { validator: validInteractMinScoreTarget, trigger: 'blur' },
        ],
        exerciseAnswerMinNum: [
          { required: true, message: '不能为空' },
          { validator: validExerciseAnswerMinNum, trigger: 'blur' },
        ],
        exerciseAnswerResult: [{ required: true, message: '不能为空' }],
        homeworkAnswerResult: [{ required: true, message: '不能为空' }],
        testNumTarget: [
          { required: true, message: '不能为空' },
          { validator: validNatrualNum, trigger: 'blur' },
        ],
        testMinNum: [
          { required: true, message: '不能为空' },
          { validator: validTestMinNum, trigger: 'blur' },
        ],
        testResult: [{ required: true, message: '不能为空' }],
        generalTestResult: [{ required: true, message: '不能为空' }],
        classAttendanceResult: [{ required: true, message: '不能为空' }],
      },
    }
  },
  created() {
    this.getCheckScaleSetting()
  },
  methods: {
    getCheckScaleSetting() {
      const courseId = this.courseId
      api.getCheckScaleSetting({ courseId }).then((data) => {
        let dataObj = data.data.data
        this.id = dataObj.id
        const resultWhiteList = [
          'attendanceResult',
          'exerciseAnswerResult',
          'generalTestResult',
          'testResult',
          'classAttendanceResult',
        ]
        for (let key in dataObj) {
          if (dataObj[key] === null) {
            if (resultWhiteList.includes(key)) {
              dataObj[key] = 1
            } else {
              dataObj[key] = 0
            }
          }
        }
        const {
          studyOnlineAndTogetherRatio,
          exerciseRatio,
          testRatio,
          generalTestRatio,
          classAttendanceRatio,
          moralRatio,
          homeworkRatio,
          interactScoreRatio,
        } = dataObj
        const tableDataValue = [
          studyOnlineAndTogetherRatio,
          '',
          '',
          exerciseRatio,
          testRatio,
          generalTestRatio,
          classAttendanceRatio,
          moralRatio,
          homeworkRatio,
          interactScoreRatio,
        ]
        this.tableForm.tableData.forEach((item, index) => {
          item.proportion = tableDataValue[index]
        })
        dataObj.currentGeneralTestTotalNum = '1'
        this.form = dataObj
      })
    },
    saveCheckScaleSetting() {
      const id = this.id
      const courseId = this.courseId
      let form = this.form
      delete form['createTime']
      delete form['updateTime']
      const tableData = this.tableForm.tableData
      const tableFormKey = [
        'studyOnlineAndTogetherRatio',
        'empty',
        'empty',
        'exerciseRatio',
        'testRatio',
        'generalTestRatio',
        'classAttendanceRatio',
        'moralRatio',
        'homeworkRatio',
        'interactScoreRatio',
      ]
      let tableForm = {}
      let ratioSum = 0
      tableData.forEach((item, index) => {
        if (item.proportion !== '') ratioSum += +item.proportion
        tableFormKey.forEach((key, index2) => {
          if (index === index2) {
            tableForm[key] = item.proportion
          }
        })
      })
      if (ratioSum !== 100) {
        return this.$message.error('考核指标输入值之和必须等于100')
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$message.error('操作失败')
        }
        api
          .saveCheckScaleSetting({ ...form, ...tableForm, id, courseId })
          .then((data) => {
            const { code, msg: message } = data.data
            if (code === 100000) {
              this.getCheckScaleSetting()
              this.$message({
                message,
                type: 'success',
              })
            }
          })
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex === 0 || rowIndex === 6) {
          return {
            rowspan: 4,
            colspan: 1,
          }
        }
        if (
          rowIndex === 1 ||
          rowIndex === 2 ||
          rowIndex === 3 ||
          rowIndex === 7 ||
          rowIndex === 8 ||
          rowIndex === 9
        ) {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
      if (columnIndex === 3 || columnIndex === 2) {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1,
          }
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  margin-top: 24px;
  border: 2px solid #eee;
  overflow: hidden;
}
.tips {
  position: relative;
  left: 50%;
  transform: translate(-30%, 30px);
  font-size: 14px;
  font-weight: 700;
  color: rgb(217, 0, 27);
}
.course_title {
  display: flex;
  align-items: center;
  height: 40px;
  background-color: #f7f7f7;
  padding-left: 26px;
  .course_title_name {
    color: #606266;
  }
  .course_save {
    width: 66px;
  }
}
.form_item_title {
  margin-bottom: 18px;
  color: #606266;
}
.form_item_title.test {
  margin-top: 40px;
}
.form_inpt {
  width: 240px;
}
.form_inpt2 {
  width: 80px;
}
.content {
  margin-left: 6px;
  color: #606266;
}
.ipt_per {
  margin-left: 10px;
  color: #606266;
}
.score_per {
  margin-right: 10px;
  color: #606266;
}
/deep/ .Interactive_rating_settings {
  .el-form-item__content {
    display: flex;
    margin-top: 2px;
    .el-form-item {
      margin-right: 26px;
    }
  }
}
</style>